/* eslint-disable @typescript-eslint/no-this-alias */
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/naming-convention */
import { Component, Prop, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from "@/theme/ThemeComponent";
import { cart } from "@/theme/Cart";
import { formatPrice } from '@/utils/products';

import { QuizDataInterface } from "./QuizContainer";


interface HiddenVariantDataInterface {
    discount_variant_id: number;
    discount_variant_price: string;
}

interface HiddenVariantInterface {
    [key: string]: HiddenVariantDataInterface;
}

@Component
export class QuizMainResult extends ThemeComponent {
    @Prop values!: HiddenVariantInterface;
    @Prop strings!: string;

    @Ref() price!: HTMLDivElement;
    @Ref() data!: HTMLScriptElement;
    @Ref() addToBag !: HTMLButtonElement;
    @Ref() recommendedProducts !: HTMLUListElement;
    @Ref() recommendationsContainer!: HTMLDivElement;

    private quizData!:QuizDataInterface;
    private productData!: ShopifyProduct;
    private hiddenVariantData!: HiddenVariantDataInterface;
    init() {
        const lc = localStorage.getItem('quizData');

        if (lc === null) {
            this.$log.error('quizData was not found in local storage');
            return;
        }

        this.quizData = JSON.parse(lc) as QuizDataInterface;

        let a = null;

        try {
            a = JSON.parse(this.data.innerHTML);
        } catch(event) {
            a = null;
            this.$log.error('JSON parse error', {
                event
            });
        }

        if (a === null) {
            return;
        }

        this.productData = a.product;
        this.process();
    }

    process() {
        const variants = this.productData.variants;
        const { grind, grind_variant, quantity} = this.quizData;
        const parts = [grind.toLowerCase(), grind_variant.toLowerCase()];
        const accuracy:number[] = [];

        /**
         * check which variant option includes number of parts
         * e.g if parts = ['ground', 'aeropress'] && option = 'ground for aeropress'
         * the accuracy for that title will be 2
         * then the index of the largest number in the accuracy array will be used to
         * grab the chosen variant
         */
        for (const variant of variants) {
            const option = variant.option1.toLowerCase();

            let count = 0;
            for (const part of parts) {
                if(option.includes(part)) {
                    count += 1;
                }
            }

            accuracy.push(count);
        }

        // get recharge subscription data for the chosen varaint
        const max = Math.max(...accuracy);
        const index = accuracy.indexOf(max);
        const variant = variants[index];
        const variantId = variant.id.toString();

        for (const key in this.values) {
            if (key === variantId) {
                this.hiddenVariantData = this.values[key];
                break;
            }
        }

        this.productPrice();
        this.addToBagEvent();
        this.showRelated();
    }


    productPrice() {
        const frequencies = [1, 2, 4];
        const price = Number(this.hiddenVariantData.discount_variant_price);

        const multipler = this.quizData.quantity;
        let index = 1;

        for (const [i, f] of frequencies.entries()) {
            if (f === this.quizData.frequency) {
                index = i;
                break;
            }
        }

        const frequency = ['week', 'two weeks', 'three weeks'][index];
        const totalPrice = formatPrice(
            (price * multipler * 100),
            String(JSON.parse(this.strings).moneyFormat)
        );

        const priceSentence = `${totalPrice} every ${frequency}`;

        this.price.textContent = priceSentence;
    }

    addToBagEvent() {
        this.$listen(this.addToBag, 'click', () => {
            cart.addItem({
                id: this.hiddenVariantData.discount_variant_id,
                quantity: this.quizData.quantity,
                properties: {
                    shipping_interval_unit_type: 'weeks',
                    shipping_interval_frequency:  `${this.quizData.frequency}`
                }
            }).then((data) => {
                document.dispatchEvent(new Event('cartAddedItem'));
                document.dispatchEvent(new Event('cartOpen'));
                this.addToBag.innerText = String(JSON.parse(this.strings).added);
                setTimeout(() => { this.addToBag.innerText = String(JSON.parse(this.strings).add); }, 3000);
            }).catch((event: unknown | null) => {
                if (event instanceof Error) {
                    this.$log.error('Cart add to bag error', event.message);
                }
            });
        });
    }

    showRelated() {
        const { alt_products } = this.quizData;

        if (alt_products.length !== 0) {
            this.recommendationsContainer.classList.remove('visually-hidden');
            for (const product of alt_products) {
                this.renderRecommendations(product);
            }
        } else {
            this.recommendationsContainer.classList.add('visually-hidden');
        }
    }

    renderRecommendations(product: any) {
        const productsContainer = this.recommendedProducts;
        const main = this;

        // Call the API to find product data by handle
        const request = new XMLHttpRequest();
        request.open('GET', `/products/${product}.js`, true);

        request.onload = function() {
            if (request.status >= 200 && request.status < 400) {
            // Success!

                // Render product card
                const data = JSON.parse(request.responseText);
                productsContainer.innerHTML += main.renderProductCard(data);

            } else {
            // We reached our target server, but it returned an error

            }
        };

        request.onerror = function() {
        // There was a connection error of some sort
        };

        request.send();
    }

    renderProductCard(product: any) {
        const card = `
            <li class="product-grid__product-item">
            <div class="single-product product-grid__product">
                <a href="${product.url}" class="single-product__image object-cover">
                <img class="slider__slide-background__image" alt="${product.alt}" src="${product.featured_image}">
                </a>
                <a href="${product.url}" class="single-product__link">
                    <h3 class="single-product__title">${product.title}</h3>
                    <div class="single-product__price single-product__price product-price" itemprop="offers" itemscope="" itemtype="http://schema.org/AggregateOffer">
                        <meta itemprop="priceCurrency" content="GBP">
                        <meta itemprop="lowPrice" content="${product.price}">
                        <small>from</small>
                        <span class="
                        single-product__price
                        product-price__money
                        " data-ref="price">
                        ${formatPrice(product.price, String(JSON.parse(this.strings).moneyFormat))}
                        </span>
                    </div>
                </a>
            </div>
            </li>
        `;

        return card;
    }
}
